import {
  Box,
  Button,
  Typography,
  IconButton,
  Input,
  InputLabel,
  InputAdornment,
  FormControl,
  TextField,
  Alert,
  Snackbar,
  Grid,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import AccountCircle from "@mui/icons-material/AccountCircle";
import LockIcon from "@mui/icons-material/Lock";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import { apiList, invokeApi } from "../../services/apiServices";
import { config } from "../../config/config";
import image from "../../assets/updatedBannerImage/updatedbannerImage2.png";
import LoginSharpIcon from "@mui/icons-material/LoginSharp";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [cookies, setCookie] = useCookies();
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  //naviagte to dashboard
  useEffect(() => {
    const userCookie = cookies.clg_user;

    if (userCookie) {
      navigate("/dashboard");
    }
  }, [cookies, navigate]);

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setOpenSnackbar(true);
  };

  const handleTogglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnackbar(false);
  };

  // Login API
  const handleLogin = async () => {
    setError(null);
    setLoading(true);

    let params = {
      email: username,
      password: password,
    };

    try {
      let response = await invokeApi(
        config.getMyCollege + apiList.userLogin,
        params,
        cookies
      );

      if (response?.status >= 200 && response?.status < 300) {
        if (response.data.responseCode === "200") {
          setCookie(
            config.cookieName,
            JSON.stringify({
              token: response.data.token,
              loginUserId: response.data.userId,
            }),
            { path: "/", maxAge: 3000000, sameSite: "strict" }
          );
          navigate("/Dashboard");
        } else if (response.data.responseCode === "HE001") {
          showSnackbar(
            "Invalid credentials. Please check your email and password.",
            "error"
          );
        } else {
          showSnackbar(
            "Something went wrong while login. Please try again later!",
            "error"
          );
        }
      } else if (
        response.data.responseMessage.includes("Password missMatch", "error")
      ) {
        showSnackbar("Password mismatch. Please check your password.", "error");
      } else if (
        response.data.responseMessage.includes("No user found", "error")
      ) {
        showSnackbar("No user found with the provided email.", "error");
      } else {
        showSnackbar(
          "Something went wrong while login. Please try again later!!",
          "error"
        );
      }
    } catch (error) {
      console.error("Error during login:", error);
      showSnackbar("Something went wrong. Please try again later!!", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Grid
        sx={{
          width: { md: "100%", xs: "100%", sm: "100%" },
          height: "100vh",
          backgroundImage: `url(${image})`,
          backgroundSize: "cover",
          backgroundPosition: "center",

          // overflow: "hidden",
          overflowY: "hidden",
          overflowX: "hidden",
        }}
      >
        <Box sx={{ height: "30px", width: "100%" }}>
          <Button
            type="button"
            sx={{
              color: "black",
              backgroundColor: "white",
              width: "80px",
              height: "30px",
              //  mt:2,
              //  ml:2
            }}
            onClick={() => navigate("/")}
          >
            <ArrowBackIcon
              sx={{
                fontSize: { md: "30px", xs: "30px", sm: "30px" },
                color: "black",
              }}
            />
            BACK
          </Button>
        </Box>

        <Grid
          sx={{
            // dispaly: "flex",
            width: "100%",
            height: "360",
            paddingTop: { md: "120px", sm: "150px", xs: "100px" },
          }}
        >
          <Box
            sx={{
              width: { md: "350px", xs: "260px", sm: "300px" },
              height: "350px",
              // margin: {md:"auto",sm:"auto",xs:"auto"},
              // marginTop:{md:"110px",xs:"110px",sm:"110px"},
              border: "1px solid white",
              backgroundColor: "white",
              borderRadius: "15px",
              // textAlign: "center",
              // justifyContent:"center",
              margin: "auto",
              // marginTop: {xs:"30%",md:"80px",sm:"80px"},
              boxShadow: "2px 0px 5px 2px #2d3436",
            }}
          >
            <Box sx={{ width: "100%" }}>
              <Typography
                sx={{
                  color: "#1D1A57",
                  fontSize: { md: "25px", xs: "20px" },
                  fontWeight: "bold",
                  textAlign: "center",
                  marginTop: "15px",
                }}
              >
                LOGIN
              </Typography>
              <Typography
                sx={{
                  color: "#1D1A57",
                  fontSize: "11px",
                  textAlign: "center",
                  fontFamily: "open Sans",
                }}
              >
                Reconnect, Rejoin, Reach for the Stars - Welcome Back!
              </Typography>
            </Box>
            <Box
              sx={{
                paddingLeft: { md: "50px", xs: "25px", sm: "50px" },
                paddingTop: "20px",
              }}
            >
              <Box sx={{}}>
                <InputLabel
                  sx={{
                    color: "#1e272e",
                    fontSize: "12px",
                    display: "flex-start",
                  }}
                >
                  Email
                </InputLabel>
                <Input
                  sx={{ width: { md: "250px", xs: "200px" } }}
                  onChange={(e) => setUsername(e.target.value)}
                  startAdornment={
                    <InputAdornment position="start">
                      <AccountCircle
                        sx={{
                          color: "#1e272e",
                          "&:hover": {
                            color: "#3498db",
                          },
                        }}
                      />
                    </InputAdornment>
                  }
                />

                <InputLabel
                  sx={{
                    color: "#1e272e",
                    fontSize: "12px",
                    paddingTop: "20px",
                  }}
                >
                  Password
                </InputLabel>
                <TextField
                  type={showPassword ? "text" : "password"}
                  // label="Password"
                  sx={{
                    width: { md: "250px", xs: "200px" },
                    // marginTop: { md: "0px", xs: "0px" },
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LockIcon
                          sx={{
                            color: "#1e272e",
                            "&:hover": {
                              color: "#3498db",
                            },
                          }}
                        />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          edge="end"
                          onClick={handleTogglePasswordVisibility}
                          sx={{
                            color: "#1e272e",
                            "&:hover": {
                              backgroundColor: "transparent",
                            },
                          }}
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  variant="standard"
                  onChange={(e) => setPassword(e.target.value)}
                />
              </Box>
            </Box>

            <Box
              sx={{ width: "100%", textAlign: "center", paddingTop: "30px" }}
            >
              <Button
                type="button"
                sx={{
                  backgroundColor: "#1D1A57",
                  color: "white",
                  width: { md: "250px", xs: "200px" },
                  height: "40px",
                  borderRadius: "15px",
                  // margin:"auto",

                  fontWeight: "bold",
                  "&:hover": {
                    backgroundColor: "#1D1A57",
                  },
                }}
                onClick={handleLogin}
                disabled={loading}
              >
                <LoginSharpIcon sx={{ margin: "10px", fontSize: "18px" }} />
                Login
              </Button>
            </Box>

            <Snackbar
              open={openSnackbar}
              autoHideDuration={2000}
              onClose={handleSnackbarClose}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              sx={{ width: "auto" }}
            >
              <Alert
                onClose={handleSnackbarClose}
                severity={snackbarSeverity}
                sx={{ width: "auto", fontSize: { xs: "14px" } }}
              >
                {snackbarMessage}
              </Alert>
            </Snackbar>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default Login;
